import { render } from "./CgStockRecord.vue?vue&type=template&id=4703e28e&scoped=true"
import script from "./CgStockRecord.vue?vue&type=script&lang=js"
export * from "./CgStockRecord.vue?vue&type=script&lang=js"

import "./CgStockRecord.vue?vue&type=style&index=0&id=4703e28e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4703e28e"]])

export default __exports__